export default __webpack_public_path__ + "static/media/gallery_04.a126b8b8.jpg";